import React, { useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import { Link } from "react-router-dom";
import SosIcon from '@mui/icons-material/Sos';// reemplaza con tu icono
import FlashOnIcon from "@mui/icons-material/FlashOn"; // rayo amarillo
import BoltIcon from '@mui/icons-material/Bolt';

// Animación rotate + scale + shake
const rotateScaleShake = keyframes`
  0% { transform: scale(1) rotate(0deg); }
  40% { transform: scale(1.05) rotate(-5deg); }
  80% { transform: scale(1.1) rotate(5deg); }
  100% { transform: scale(1) rotate(0deg); }
`;

export default function CustomFloatingButton() {
  const [hover, setHover] = useState(false);

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        position: "fixed",
        zIndex: 50,
        bgcolor: "black",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column", // para apilar el rayo arriba del icono
        boxShadow: 4,
        borderTopLeftRadius: { xs: "9999px", md: "9999px" },
        borderTopRightRadius: { xs: "9999px", md: 0 },
        borderBottomLeftRadius: { xs: 0, md: "9999px" },
        borderBottomRightRadius: { xs: "9999px", md: 0 },
        width: { xs: "180px", md: "96px" },
        height: { xs: "85px", md: "180px" },
        right: { xs: "50%", md: "-15px" },
        bottom: { xs: "-15px", md: 0 },
        top: { md: "50%" },
        transform: {
          xs: "translateX(50%)",
          md: "translateY(-50%)",
        },
        cursor: "pointer",
      }}
    >
      {/* Icono de rayo amarillo */}
      {hover && (
        <BoltIcon
          sx={{
            
            color: "#f6bc00ff",
            fontSize: { xs: 30, md: 25 },
            animation: `${keyframes`
              0% { transform: translateY(0) scale(1); opacity:1; }
              50% { transform: translateY(-5px) scale(1.1); opacity:0.8; }
              100% { transform: translateY(0) scale(1); opacity:1; }
            `} 0.6s infinite`,
          }}
        />
      )}

      {/* Botón principal */}
      <Button
        component={Link}
        to="/personaliza-tu-dosis?paso=1"
        sx={{
          color: "#DCD9D7",
          transition: "transform 0.2s ease-in-out",
          animation: hover ? `${rotateScaleShake} 0.6s ease-in-out infinite` : "none",
        }}
      >
        <Typography sx={{ fontSize: { xs: 10, md: 8 } }}>Comenzar</Typography>
      </Button>
    </Box>
  );
}
